import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import './government-styles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';



function GovernmentContract() {
  const globalClasses = globalUseStyles()
  return (
  <ThemeProvider theme={theme}>
    <Container className={"governmentContractStyle"} maxWidth={false} component="section">
      <Grid className={globalClasses.containerVertPadding} container>
        <Grid className={globalClasses.containerSmall} container >
          <Grid item xs={12} md={12}  >
            <Typography variant="h2">Contract Vehicles, IDIQs and BPAs</Typography>
            <Typography variant="body1">
              <ul>
                <li>Lorem Ipsum dolor sit amet</li>
                <li>Consecetur adipsicing elit</li>
                <li>Aenean euismod bibendum lacreet</li>
                <li>Proin gravida dolor</li>
                <li>Sit amet lacus accumsan</li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </ThemeProvider>
  );
};

export default GovernmentContract;